"use client";

import type { JSX, ReactNode } from "react";

import { cn } from "@/lib/utils";

interface ChatSplitViewProps {
  messages: ReactNode[];
  listFooter?: ReactNode;
  detailContent: ReactNode;
}

function MessagesPanel({
  messages,
  listFooter,
}: {
  messages: ReactNode[];
  listFooter?: ReactNode;
}): JSX.Element {
  const className = cn([
    "w-full md:w-64 lg:w-72 xl:w-80 overflow-auto flex-shrink-0",
    "border border-border md:border-0 md:border-r",
    "rounded-2xl md:rounded-none",
    "mx-4 md:mx-0",
  ]);

  return (
    <div className={className}>
      {messages}
      {listFooter}
    </div>
  );
}

function ContentPanel({
  detailContent,
}: {
  detailContent: ReactNode;
}): JSX.Element {
  return (
    <div className="hidden md:flex md:items-center flex-col flex-1 bg-surface-subtle/30 overflow-auto p-5">
      {detailContent}
    </div>
  );
}

export default function ChatSplitView({
  messages,
  listFooter,
  detailContent,
}: ChatSplitViewProps): JSX.Element {
  return (
    <div className="flex overflow-y-auto border-t border-border h-full">
      <MessagesPanel messages={messages} listFooter={listFooter} />
      <ContentPanel detailContent={detailContent} />
    </div>
  );
}
